import { useEffect, useState } from 'react';

/**
 * Fetch a bearer-gated blob and expose it as an object URL, revoking on cleanup
 * or dependency change. `fetcher` returns the object URL (already created). Pass
 * a stable `key` so the effect re-runs only when the target changes; bump
 * `version` to force a refetch after an edit.
 */
export function useObjectUrl(
  fetcher: (() => Promise<string>) | null,
  key: string,
  version = 0,
): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!fetcher) { setUrl(null); return undefined; }
    let active = true;
    let made: string | null = null;
    void fetcher()
      .then((u) => { if (active) { made = u; setUrl(u); } else URL.revokeObjectURL(u); })
      .catch(() => { if (active) setUrl(null); });
    return () => { active = false; if (made) URL.revokeObjectURL(made); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, version]);
  return url;
}
